import { useState } from "react";
import { Modal, Box, Typography, Button, Grid } from "@mui/material";
import { PALETTE } from "../Theme/Palette";

const ConfirmModalSelectCenter = ({
  message,
  open,
  onClose,
  onSubmit,
  info = { name: "", details: "" },
}) => {
  const [messageText, setMessageText] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit();
  };

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Box component="form" width="100%" onSubmit={handleSubmit}>
        <Box
          width="90% !important"
          maxWidth="500px"
          marginX="auto"
          sx={{
            backgroundColor: "#FFF",
            boxSizing: "border-box",
            padding: "2rem",
            borderRadius: "1.5rem",
          }}
        >
          <Grid item width="100%">
            <Typography
              fontSize="0.85rem"
              fontWeight={400}
              letterSpacing="-0.0175rem"
              sx={{ direction: "rtl", color: PALETTE.eightth }}
            >
              شما مرکز {info.name} را انتخاب کرده‌‌اید
              <br />
              {info.details}
              <br />
              آیا اطمینان دارید ؟
            </Typography>
          </Grid>
          <Box display="flex" flexDirection="row-reverse" width="100%" mt="1rem">
            <Button
              variant="m1"
              type="submit"
              sx={{
                flex: 1,
                marginLeft: 1,
              }}
            >
              تایید
            </Button>
            <Button
              variant="m1"
              type="button"
              sx={{
                flex: 1,
                color: "#4C466F",
                marginRight: 1,
                backgroundColor: "#E8E8E8 !important",
                background: "none",
                fontWeight: 500,
                fontSize: "16px",
              }}
              onClick={() => {
                onClose();
                setMessageText("");
              }}
            >
              انصراف
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmModalSelectCenter;
